import loadable from '@loadable/component';
import React from 'react';
import {
    SearchCardDesktopExperimentValues,
    SearchCardMobileExperimentValues,
} from '../../types/Experiments';
import { DiscoverEventCardProps } from './types';

//Directly importing variant 4 instead of a loadable to minimize unnecessary logic
import { DiscoverHorizontalEventCardVariantFour } from './Horizontal/DiscoverHorizontalEventCardVariantFour';

type EventCardMobileImportMap = Record<
    SearchCardMobileExperimentValues,
    React.FunctionComponent<DiscoverEventCardProps>
>;

type EventCardDesktopImportMap = Record<
    SearchCardDesktopExperimentValues.control,
    React.FunctionComponent<DiscoverEventCardProps>
>;

export const EXPERIMENT_SEARCH_CARD_MAP_MOBILE: EventCardMobileImportMap = {
    [SearchCardMobileExperimentValues.control]: loadable(
        () => import('./Horizontal/DiscoverHorizontalEventCard'),
    ),
    [SearchCardMobileExperimentValues.verticalA]: loadable(
        () => import('./Vertical/DiscoverVerticalEventCardVariantA'),
    ),
    [SearchCardMobileExperimentValues.verticalB]: loadable(
        () => import('./Vertical/DiscoverVerticalEventCardVariantB'),
    ),
};

export const EXPERIMENT_SEARCH_CARD_MAP_DESKTOP: EventCardDesktopImportMap = {
    [SearchCardDesktopExperimentValues.control]:
        DiscoverHorizontalEventCardVariantFour,
};

export type { DiscoverEventCardProps };
